import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import StudyAbroadBanner4 from '@/assets/banners/bg-abroad-banner.webp';
import StudyAbroadBanner from '@/assets/banners/bg-study-abroad-c.webp';
import { useGlobalContext } from '@/context/GlobalContext';

// import WorldMapBanner from '@/assets/banners/mapbg.webp';
// import { useGlobalContext } from "@/app/context/GlobalContext";
// import { targetCountries } from '@/constants/constant';

interface HeroSectionProps {
  title?: string;
  countryId?: number | string;
  countryUrl?: string;
  countryData?: any;
}

const HeroSection = ({ title, countryId, countryUrl }: HeroSectionProps) => {
  const { setIsLeadFormOpen, setLeadFormData } = useGlobalContext();
  // const [filteredCountriesData, setFilteredCountriesData] = useState([]);

  const [index, setIndex] = useState(0);
  const [displayedService, setDisplayedService] = useState('');
  const [deleting, setDeleting] = useState(false);
  const typingSpeed = 60;
  const deletingSpeed = 50;

  const handleOpen = () => {
    setLeadFormData({
      source: title ? `study-abroad-${title}` : 'Study Abroad',
      country: countryId ?? null,
      title: title ?? 'Study Abroad',
    });
    setIsLeadFormOpen(true);
    console.log('Lead form opened');
  };

  /* -------------------------------- useEffect ------------------------------- */

  useEffect(() => {
    let typingTimer: any;

    if (deleting) {
      typingTimer = setTimeout(() => {
        setDisplayedService((prev) => prev.slice(0, -1));

        if (displayedService === '') {
          setDeleting(false);
          setIndex((prevIndex) => (prevIndex + 1) % services.length);
        }
      }, deletingSpeed);
    } else {
      const fullText = services[index];
      typingTimer = setTimeout(() => {
        setDisplayedService((prev) => fullText.slice(0, prev.length + 1));

        if (displayedService === fullText) {
          setTimeout(() => setDeleting(true), 1500);
        }
      }, typingSpeed);
    }

    return () => clearTimeout(typingTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayedService, deleting, index]);

  const services = [
    'Top Colleges & Universities',
    'Exams & Scholarships',
    'Admission Assistance',
    'Visa & Accommodations',
  ];

  // useEffect(() => {
  //   const result = countryData
  //     ?.filter((country: any) => {
  //       return targetCountries?.some((target) => {
  //         const targetNameLower = target?.country_name.toLowerCase();
  //         const abbreviationLower = country?.abbreviation?.toLowerCase() ?? '';
  //         const countryNameLower = country?.country_name?.toLowerCase() ?? '';
  //         return (
  //           targetNameLower === abbreviationLower ||
  //           targetNameLower === countryNameLower ||
  //           abbreviationLower === targetNameLower ||
  //           countryNameLower === targetNameLower
  //         );
  //       });
  //     })
  //     .map((country: any) => {
  //       const target = targetCountries?.find((target) => {
  //         const targetNameLower = target?.country_name.toLowerCase();
  //         const abbreviationLower = country?.abbreviation?.toLowerCase() ?? '';
  //         const countryNameLower = country?.country_name?.toLowerCase() ?? '';

  //         return (
  //           targetNameLower === abbreviationLower ||
  //           targetNameLower === countryNameLower ||
  //           abbreviationLower === targetNameLower ||
  //           countryNameLower === targetNameLower
  //         );
  //       });

  //       return {
  //         ...country,
  //         left: target?.left,
  //         right: target?.right,
  //       };
  //     });

  //   setFilteredCountriesData(result);
  // }, [countryData]);

  return (
    <div className="relative h-full bg-black font-inter">
      <div className={`absolute ${countryId ? 'inset-0 bg-black opacity-10 md:opacity-35' : ''} z-10`}></div>
      <div className="min-h-[288px] w-full lg:min-h-[400px]">
        <Image
          src={countryId ? StudyAbroadBanner4 : StudyAbroadBanner}
          alt={`Explore top colleges & Universities in ${title ?? 'Abroad'} with CollegeHai`}
          sizes="(max-width: 1024px) 100vw, 1200px"
          className="-z-50 h-72 max-h-72 w-full object-fill object-center lg:h-[25rem] lg:max-h-[25rem]"
          quality={10}
          priority
        />
      </div>
      <div
        className={`flex items-center ${
          countryId ? 'justify-center' : 'justify-start'
        } absolute inset-0 z-50 mx-auto max-w-screen-xl`}
      >
        <div className={`w-full ${!countryId && 'lg:basis-2/5'}`}>
          <h1
            className={`gap-x-2 text-left font-inter text-base font-bold text-white lg:text-3xl ${
              countryId ? 'flex items-center justify-center' : 'flex items-center justify-center md:block lg:min-h-24'
            }`}
          >
            {title ? `Explore ${title}` : <>Explore Abroad </>}{' '}
            <span className="text-blue-200"> {displayedService}</span>
          </h1>
          <div
            className={`mt-5 flex items-center gap-x-4 text-xs lg:mt-10 lg:text-sm ${
              countryId ? 'justify-center' : 'justify-center lg:justify-start'
            }`}
          >
            <Link
              href={`/colleges-in-${countryUrl?.replace('study-in-', '')?.toLowerCase() ?? 'abroad'}`}
              className="w-32 rounded bg-primary-orange py-2 text-center text-white hover:scale-105 lg:w-44"
            >
              Explore College
            </Link>
            <button className="w-32 rounded bg-primary py-2 text-white hover:scale-105 lg:w-44" onClick={handleOpen}>
              Apply Now
            </button>
          </div>
        </div>
        {/*
        {!countryId && (
          <div className="relative hidden w-full flex-1 basis-4/5 lg:block">

            <Image
              src={WorldMapBanner}
              alt={"World Map"}
              width={1000}
              height={400}
              className="z-50 h-fit w-full"
            />
            {filteredCountriesData?.map((country: any) => (
              <div
                key={country?.id}
                style={{
                  position: "absolute",
                  left: `${country?.left}%`,
                  top: `${country?.right}%`,
                }}
                className="group cursor-pointer"
              >

                <div className="absolute -top-7 left-1/2 hidden -translate-x-1/2 flex-col items-center group-hover:flex">
                  <Link
                    href={`/study-abroad/${country?.country_url?.toLowerCase()}`}
                    className="block w-fit rounded bg-[#505ee9] p-1 text-xxs text-white hover:scale-110"
                  >
                    <p>{country?.abbreviation || country?.country_name}</p>
                  </Link>
                  <div
                    className="absolute bottom-[-8px] right-[30%] size-0 translate-x-1/2 rotate-180 border-x-[6px] border-b-8 border-[#505ee9] border-x-transparent"
                  ></div>
                </div>
                <Link
                  href={`/study-abroad/${country?.country_url?.toLowerCase()}`}
                  className="flex size-6 items-center justify-center"
                >
                  <div className="size-3 rounded-full border-2 border-blue-500 bg-transparent"></div>
                </Link>
              </div>
            ))}
          </div>
        )}  */}
      </div>
    </div>
  );
};

export default HeroSection;
